import React, {useEffect, useState} from 'react';
import _ from "lodash";
import AddEditPinterestPin from "./add-edit-pinterest-pin";
import PinterestPinFilters from "./pinterest-pin-filters";
import {searchPinterestPinsWithSearchCriteria} from "../../services/pinterest-pin-data.service";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PINTEREST_PIN_FIELDS_LIST} from "../../constants/pinterest-pin.constant";
import GoToLink from "../../../common/ui/go-to-link";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const defaultFilterCriteria: any = {};

const PinterestPinsList = () => {
    const [pinterestPinsList, setPinterestPinsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPinterestPinList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const pinterestPinListResult = await searchPinterestPinsWithSearchCriteria(searchCriteriaList);

        setPinterestPinsList(pinterestPinListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPinterestPinList();
    }, [filterCriteria]);

    const refreshPinterestPinList = async () => {
        await getPinterestPinList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Pinterest Pin
                    </div>

                    {/*<PinterestPinFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    <div className="ml-2">
                        <AddEditPinterestPin
                            isAddPinterestPin={true}
                            refreshPinterestPinList={refreshPinterestPinList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={pinterestPinsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Pinterest Pins'}/>

                    {pinterestPinsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PINTEREST_PIN_FIELDS_LIST?.map((pinterestPinField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${pinterestPinField?.cssClass}`}>{pinterestPinField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {pinterestPinsList?.map((pinterestPin, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PINTEREST_PIN_FIELDS_LIST?.map((pinterestPinField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${pinterestPinField?.cssClass}`}>
                                                {pinterestPinField?.optionsMap &&
                                                    <>{pinterestPinField?.optionsMap[pinterestPin[pinterestPinField?.attribute]]?.name}</>
                                                }

                                                {!pinterestPinField?.optionsMap &&
                                                    <>
                                                        {pinterestPin[pinterestPinField?.attribute]}

                                                        {pinterestPinField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {pinterestPin[pinterestPinField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-40">
                                        <div className="flex justify-center">
                                            <AddEditPinterestPin
                                                isEditPinterestPin={true}
                                                selectedPinterestPin={pinterestPin}
                                                refreshPinterestPinList={refreshPinterestPinList}/>

                                            <GoToLink
                                                cssClass="ml-2 button-green px-2 py-1"
                                                label="Design"
                                                url={`pinterest-pins/${pinterestPin?.id}/design`}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default PinterestPinsList
